<template>
<a href="/purchase/index.html" :class="current" :data-scp="scp">
	<i class="icon icon-cart"></i><span>购物车</span>
</a>
</template>
<script>
export default {
	props: ['current', 'scp']
}
</script>